export const decimalFormatter = new Intl.NumberFormat('en-En', {
  style: 'decimal',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});
